import { render } from "./Publish.vue?vue&type=template&id=cef38146&scoped=true"
import script from "./Publish.vue?vue&type=script&lang=js"
export * from "./Publish.vue?vue&type=script&lang=js"

import "./Publish.vue?vue&type=style&index=0&id=cef38146&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cef38146"]])

export default __exports__